import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Box, IconButton } from "@mui/material";
import PropTypes from "prop-types";

export default function SortableDateHeader({ label, sortOrder, onSort }) {
  const handleClick = (order) => (e) => {
    e.stopPropagation();
    e.preventDefault();
    onSort(order);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
      <span>{label}</span>
      <IconButton
        onClick={handleClick("asc")}
        size="small"
        aria-label={`Sort ${label} oldest first`}
      >
        <ArrowUpwardIcon sx={{ color: sortOrder === "asc" ? "white" : "inherit" }} />
      </IconButton>
      <IconButton
        onClick={handleClick("desc")}
        size="small"
        aria-label={`Sort ${label} newest first`}
      >
        <ArrowDownwardIcon sx={{ color: sortOrder === "desc" ? "white" : "inherit" }} />
      </IconButton>
    </Box>
  );
}

SortableDateHeader.propTypes = {
  label: PropTypes.string.isRequired,
  sortOrder: PropTypes.oneOf(["asc", "desc", null]),
  onSort: PropTypes.func.isRequired,
};
